import * as React from 'react';
import * as _ from 'lodash';

import * as DetailFormCommon from './common';
import * as KendoWrappers from '../../common/kendoforms/componentwrappers';

export const ClientNotes = ({
    appText,
    handleFormInputChange,    
    handleSubmitForm,
    handleSaveChanges,
    numFormChanges,    
    handleSaveButton,
    formData,
    defaultInputProps,
    sectionTitle,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    let inputPropsFullWidth = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
        // handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
    }); 

    let inputPropsFullWidthTextDebounced = _.merge({}, defaultInputProps, {
        // onChange: (n, v) => { handleFormInputChange(n, v); },
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
    });

    let inputProps = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
    });

    let inputPropsFullWidthOwnRow = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
        colLabelXs: 12,
        colInputXs: 12,
    });

    let inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
        // onChange: (o) => { handleFormInputChange({target: { type: 'virtualized-select' }}, o); }
    });

    const inputPropsRoleCheckbox = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
    });

    return (      
        <DetailFormCommon.ClientDetailFormSection title={sectionTitle}>
            <div>                               
                <DetailFormCommon.InventoryNoteRow key={`edit-client-note-row-notes-add`}>
                    <DetailFormCommon.InventoryNote
                        authorText={appText('client-notes-add-author-text')}
                        dateText=""
                        onClickDelete={(e, o) => handleFormInputChange(e, o)}
                        onClickSave={(e) => handleSaveButton(e)}
                        deleteButtonVisible={false}
                        saveButtonVisible={true}
                    >
                        <KendoWrappers.KendoTextarea
                            name="clientNotesAdd"
                            label=""
                            rows={2}
                            cols={40}
                            value={formData.clientNotesAdd}
                            {...inputPropsFullWidthOwnRow} />
                    </DetailFormCommon.InventoryNote>
                </DetailFormCommon.InventoryNoteRow>
    
                <DetailFormCommon.ClientNotes
                    name="clientNotesDelete"
                    clientNotes={formData.clientNotes}
                    onClickDelete={(e, o) => handleFormInputChange(e, o)}
                    onClickSave={(e) => handleSaveButton(e)}
                    deleteButtonVisible={true}
                    saveButtonVisible={false}
                />              
            </div>
        </DetailFormCommon.ClientDetailFormSection>
    );
};



// WEBPACK FOOTER //
// ./src/client/detail-form/client-notes.tsx